import { useDebounce } from 'use-debounce';
import { useLocation } from '../context/LocationContext';
import { useCustomerRegistry, useCustomerRegistryEnabled } from '../hooks/useCustomerRegistry';
import { SearchHit } from '@ordr-as/ordr-service-types/epos';
import InvoiceField from './InvoiceField';
import { useEffect, useState } from 'react';

const invoiceDynamicFields = [
  {
    name: 'externalReference',
    type: 'TEXT_COMBO_BOX',
    required: true,
    displayLabel: 'Customer',
  },
  {
    name: 'referencePerson',
    type: 'TEXT_SINGLE_LINE',
    required: false,
    displayLabel: 'Reference Person',
  },
  {
    name: 'comment',
    type: 'TEXT_SINGLE_LINE',
    required: false,
    displayLabel: 'Comment',
  },
];

type InvoiceInfoContainerProps = {
  invoiceFieldValues?: {
    customerRegistryId?: string | undefined;
    customerName?: string | undefined;
    referencePerson?: string | undefined;
    comment?: string | undefined;
  };
  setInvoiceFieldValues: React.Dispatch<
    React.SetStateAction<{
      customerRegistryId?: string | undefined;
      customerName?: string | undefined;
      referencePerson?: string | undefined;
      comment?: string | undefined;
    }>
  >;
};

const InvoiceInfoContainer = (props: InvoiceInfoContainerProps) => {
  const { invoiceFieldValues, setInvoiceFieldValues } = props;
  const { location } = useLocation();
  const { data: customerRegistryEnabledDto } = useCustomerRegistryEnabled(location.id);
  const [searchText, setSearchText] = useDebounce<string | undefined>(invoiceFieldValues?.customerName, 300);
  const { data: customerRegistry } = useCustomerRegistry(location.id, searchText);
  const [dynamicFieldValues, setDynamicFieldValues] = useState<{ [key: string]: string }>({
    externalReference: invoiceFieldValues?.customerRegistryId ?? invoiceFieldValues?.customerName ?? '',
    referencePerson: invoiceFieldValues?.referencePerson ?? '',
    comment: invoiceFieldValues?.comment ?? '',
  });

  useEffect(() => {
    const externalReference = dynamicFieldValues['externalReference'];
    const customerRegistryId = customerRegistryEnabledDto?.enabled ? externalReference : undefined;
    const customer = customerRegistry?.hits.find(
      (customer: SearchHit) => customer.externalReference === externalReference
    );
    const customerName = !customerRegistryEnabledDto?.enabled ? externalReference : customer?.name;
    const referencePerson = dynamicFieldValues['referencePerson'];
    const comment = dynamicFieldValues['comment'];
    setInvoiceFieldValues({ customerRegistryId, customerName, referencePerson, comment });
  }, [customerRegistry?.hits, customerRegistryEnabledDto?.enabled, dynamicFieldValues, setInvoiceFieldValues]);

  return (
    <>
      {invoiceDynamicFields?.map((unintegratedField) => (
        <InvoiceField
          key={unintegratedField.displayLabel}
          unintegratedField={unintegratedField}
          dyamicFieldValues={dynamicFieldValues}
          setDynamicFieldValues={setDynamicFieldValues}
          customerRegistryEnabledDto={customerRegistryEnabledDto}
          customerRegistry={customerRegistry}
          setSearchText={setSearchText}
        />
      ))}
    </>
  );
};

export default InvoiceInfoContainer;
